(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
/* ── StickyHeader custom element ── */
class StickyHeader extends HTMLElement {
  constructor() { super(); }
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }
  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }
  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}
customElements.define('sticky-header', StickyHeader);

/* ── Voolga Mega Menu Controller ── */
(function () {
  'use strict';

  const CLOSE_DELAY = 180;   // ms before panel closes after cursor leaves
  const OPEN_DELAY  = 60;    // ms before panel opens (prevents flash on fast cursors)

  // Cache panel positions — recompute on scroll/resize
  const sectionHeader = document.querySelector('.section-header');
  const megaPanels    = document.querySelectorAll('.voolga-mega');
  const navPill       = document.querySelector('.voolga-nav-pill');

  function getPanelTop() {
    if (!sectionHeader) return 0;
    const rect = sectionHeader.getBoundingClientRect();
    // Guard: if header is hidden (slides up), rect.bottom may be <= 0
    return Math.max(rect.bottom, 0);
  }

  function pinPanels() {
    const top = getPanelTop() + 'px';
    megaPanels.forEach(function (panel) { panel.style.top = top; });
  }

  pinPanels();
  window.addEventListener('scroll',  pinPanels, { passive: true });
  window.addEventListener('resize',  pinPanels, { passive: true });

  // Also re-pin after header transition (sticky reveal/hide)
  if (sectionHeader) {
    sectionHeader.addEventListener('transitionend', pinPanels);
  }

  /* ── Pill highlight that follows hovered nav item ── */
  function movePill(link) {
    if (!navPill || !link) return;
    const navRect  = navPill.parentElement.getBoundingClientRect();
    const linkRect = link.getBoundingClientRect();
    navPill.style.left  = (linkRect.left - navRect.left) + 'px';
    navPill.style.width = linkRect.width + 'px';
  }

  /* ── Per-item open/close logic ── */
  document.querySelectorAll('.voolga-item').forEach(function (item) {
    const trigger = item.querySelector('.voolga-link[aria-haspopup]');
    const panel   = item.querySelector('.voolga-mega');
    if (!trigger || !panel) return;

    let openTimer  = null;
    let closeTimer = null;

    function openPanel() {
      clearTimeout(closeTimer);
      closeTimer = null;
      openTimer = setTimeout(function () {
        panel.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        pinPanels();
      }, OPEN_DELAY);
    }

    function closePanel() {
      clearTimeout(openTimer);
      openTimer = null;
      closeTimer = setTimeout(function () {
        panel.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }, CLOSE_DELAY);
    }

    function cancelClose() { clearTimeout(closeTimer); closeTimer = null; }

    // Trigger hover
    trigger.addEventListener('mouseenter', function () {
      movePill(trigger);
      openPanel();
    });
    trigger.addEventListener('mouseleave', closePanel);

    // Panel hover — cancel close while mouse is inside
    panel.addEventListener('mouseenter', cancelClose);
    panel.addEventListener('mouseleave', closePanel);

    // Keyboard: Enter / Space opens; Escape closes
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const isOpen = panel.classList.contains('is-open');
        if (isOpen) {
          panel.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          panel.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          pinPanels();
          // Move focus to first focusable element in panel
          const firstLink = panel.querySelector('a, button');
          if (firstLink) firstLink.focus();
        }
      }
      if (e.key === 'Escape') {
        panel.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });

    // Escape from inside the panel
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        panel.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });

    // Click outside closes
    document.addEventListener('click', function (e) {
      if (!item.contains(e.target) && !panel.contains(e.target)) {
        panel.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  });

  /* ── Plain links: move pill on hover ── */
  document.querySelectorAll('.voolga-item').forEach(function (item) {
    const link = item.querySelector('.voolga-link:not([aria-haspopup])');
    if (!link) return;
    link.addEventListener('mouseenter', function () { movePill(link); });
  });

  /* ── Cursor spotlight inside mega panel ── */
  megaPanels.forEach(function (panel) {
    const inner = panel.querySelector('.voolga-mega-inner');
    if (!inner) return;

    panel.addEventListener('mousemove', function (e) {
      const rect = inner.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width  * 100).toFixed(1) + '%';
      const y = ((e.clientY - rect.top)  / rect.height * 100).toFixed(1) + '%';
      inner.style.setProperty('--spotlight-x', x);
      inner.style.setProperty('--spotlight-y', y);
    });
  });

  /* ── Per-card shimmer spotlight ── */
  document.querySelectorAll('.voolga-feat-card').forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      const rect = card.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width  * 100).toFixed(1) + '%';
      const y = ((e.clientY - rect.top)  / rect.height * 100).toFixed(1) + '%';
      card.style.setProperty('--card-mx', x);
      card.style.setProperty('--card-my', y);
    });
  });

})();

  } catch(e) { console.error(e); }
})();
})();
